
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <p className="text-gray-400 text-sm">
              {t('site_title')}
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer_contact_title')}</h3>
            <div className="space-y-2 text-sm text-gray-400">
              <p>📧 info@tokyorent.biz</p>
              <p>🕒 {t('footer_support_hours')}</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400">{t('footer_copyright')}</p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer mt-2 md:mt-0"
          >
            {t('footer_link')}
          </a>
        </div>
      </div>
    </footer>
  );
}
